import React from "react";
import { useNavigate } from "react-router-dom";
import "./Inbox.css"; // Uses player-inbox scoped CSS

const Inbox = ({ userId }) => {
  const navigate = useNavigate();

  // ✅ Add playerId so Chats (and future inbox features) can use it if needed
  const playerId = localStorage.getItem("playerId") || null;

  const handleNavigate = (path) => {
    navigate(path, { state: { userId, playerId } });
  };

  return (
    <div className="player-inbox">
      <div className="inbox-card">
        <h3 className="card-title">Inbox</h3>

        <div className="button-stack">
          {/* Empty top box */}
          <button disabled className="empty-box"></button>

          {/* Main active feature */}
          <button onClick={() => handleNavigate("/player/chats")}>
            Chats
          </button>

          {/* Empty bottom box */}
          <button disabled className="empty-box"></button>
        </div>
      </div>
    </div>
  );
};

export default Inbox;





















